// extracted by mini-css-extract-plugin
export default {"card":"_Y-z","carouselContainer":"aZ-z","carouselContent":"bZ-z"};